/**
 * Reorder array immutably.
 * Returns new array with item moved from fromIndex to toIndex.
 */
export const reorderArray = <T>(array: T[], fromIndex: number, toIndex: number): T[] => {
  if (fromIndex === toIndex) return array;
  if (fromIndex < 0 || fromIndex >= array.length) return array;
  if (toIndex < 0 || toIndex >= array.length) return array;

  const item = array[fromIndex];
  const withoutItem = array.filter((_, i) => i !== fromIndex);

  return [...withoutItem.slice(0, toIndex), item, ...withoutItem.slice(toIndex)];
};

/**
 * Insert item into array at specific index immutably.
 */
export const insertAtIndex = <T>(array: T[], item: T, index?: number): T[] => {
  const insertAt = index ?? array.length;
  const clampedIndex = Math.max(0, Math.min(insertAt, array.length));

  return [...array.slice(0, clampedIndex), item, ...array.slice(clampedIndex)];
};
